import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../app/store'
import { Item } from '../features/TodoSlice'
import TodoItem from './TodoItem'

const DoneTodos = () => {
  const doneTasks = useSelector((state: RootState) => state.todos.filter(item => item.status === 'done'))

  return (
    <div data-testid="todo_list_new" className='undone_block'>
      <h3 className='undone_block__title'>Done</h3>
      {
          doneTasks.map((todo: Item) => 
              <TodoItem
                  key={todo.id}
                  id={todo.id}
                  title={todo.title}
                  description={todo.description}
                  deadline={todo.deadline}
                  status={todo.status}
              />)
      }        
    </div>
  )
}

export default DoneTodos